module.exports = __webpack_public_path__ + "img/ico-bars.217caa1c.svg";